import React from 'react';
import {
	ModalContainer,
	Paragraph,
	tokens,
	Radio,
	Label,
	Select,
} from '@welbe/web-design-system';
import UserAdd from 'App/assets/img/candidate.svg?url';
import { Button } from '@welbe/design-system';

import {
	Container,
	ContentButton,
	Icon,
	RadioContainer,
} from './ModalAssignJobProfile.styles';

import { useModalAssignJobProfile } from './ModalAssignJobProfile.hooks';
import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';

type ModalAssignJobProfileProps = {
	isLoading: boolean;
	risksProfile: any;
	expositionAreas: any;
	handleClose: () => void;
	handleAssignJobProfile: (risk: string) => void;
};

export const ModalAssignJobProfile = ({
	isLoading,
	risksProfile,
	expositionAreas,
	handleClose,
	handleAssignJobProfile,
}: ModalAssignJobProfileProps): JSX.Element => {
	const {
		step,
		kindOfProfile,
		selectedRiksProfile,
		selectedExpositionArea,
		handleNext,
		handleChangeKingOfProfile,
		handleSelectRiskProfile,
		handleSelectExpositionArea,
	} = useModalAssignJobProfile({
		handleClose,
		handleAssignJobProfile,
	});

	const RenderSteps = () => {
		if (step === 0) {
			return (
				<Container>
					<Paragraph
						fontWeight="600"
						fontSize="16px"
						textAlign="center"
						padding="20px 0px 20px 0px"
					>
						Asignar colaboradores
					</Paragraph>

					<RadioContainer>
						<Radio
							name="manualLink"
							value={JobProfileType.RISK_PROFILE}
							size="small"
							onChange={() =>
								handleChangeKingOfProfile(JobProfileType.RISK_PROFILE)
							}
							checked={kindOfProfile === JobProfileType.RISK_PROFILE}
						/>
						<Label
							fontWeight={600}
							fontSize={14}
							margin="0"
							onClick={() =>
								handleChangeKingOfProfile(JobProfileType.RISK_PROFILE)
							}
						>
							Asignar a perfil de riesgo
						</Label>
					</RadioContainer>
					<RadioContainer>
						<Radio
							name="csvLink"
							value={JobProfileType.EXPOSITION_AREA}
							size="small"
							onChange={() =>
								handleChangeKingOfProfile(JobProfileType.EXPOSITION_AREA)
							}
							checked={kindOfProfile === JobProfileType.EXPOSITION_AREA}
						/>
						<Label
							fontWeight={600}
							fontSize={14}
							margin="0"
							onClick={() =>
								handleChangeKingOfProfile(JobProfileType.EXPOSITION_AREA)
							}
						>
							Asignar a área de exposición
						</Label>
					</RadioContainer>

					<ContentButton>
						<Button
							id="confirmInactiveEmployee"
							key="2"
							type="button"
							onClick={handleNext}
							width="150px"
							loading={isLoading}
						>
							Confirmar
						</Button>
						<a onClick={() => (isLoading ? undefined : handleClose())}>
							<Paragraph
								color={tokens.color_primary}
								textAlign="center"
								cursor={'pointer'}
								fontWeight="500"
							>
								Cancelar
							</Paragraph>
						</a>
					</ContentButton>
				</Container>
			);
		}
		return (
			<Container>
				<Paragraph
					fontWeight="600"
					fontSize="16px"
					textAlign="center"
					padding="20px 0px 0px 0px"
				>
					Asignar colaboradores
				</Paragraph>
				<Paragraph
					fontWeight="600"
					fontSize="16px"
					textAlign="center"
					padding="30px 0px 30px 0px"
				>
					¿Con que perfil de riesgo vincularás a estos colaboradores?
				</Paragraph>

				{kindOfProfile === JobProfileType.RISK_PROFILE ? (
					<Select
						id="riskProfile"
						placeholder="Selecione..."
						label="Perfil de riesgo"
						initialSelected={selectedRiksProfile}
						options={risksProfile}
						onChange={handleSelectRiskProfile}
						searchable
					/>
				) : (
					<Select
						id="expositionAreas"
						placeholder="Selecione..."
						label="Áreas de exposición"
						initialSelected={selectedExpositionArea}
						options={expositionAreas}
						onChange={handleSelectExpositionArea}
						searchable
					/>
				)}

				<ContentButton>
					<Button
						id="confirmInactiveEmployee"
						key="2"
						type="button"
						onClick={handleNext}
						width="150px"
						loading={isLoading}
					>
						Confirmar
					</Button>
					<a onClick={handleClose}>
						<Paragraph
							color={tokens.color_primary}
							textAlign="center"
							cursor={'pointer'}
							fontWeight="500"
						>
							Cancelar
						</Paragraph>
					</a>
				</ContentButton>
			</Container>
		);
	};

	return (
		<>
			<ModalContainer
				visible
				height={step === 0 ? '340px' : '400px'}
				zIndex={1100}
				headerIcon={<Icon src={UserAdd} />}
				closeOnlyOnTheButton
			>
				<RenderSteps />
			</ModalContainer>
		</>
	);
};
